import React from 'react';

interface ProgressBarProps {
  value: number;
  max: number;
  color?: 'primary' | 'success' | 'warning' | 'danger' | 'secondary';
  showPercentage?: boolean;
  height?: string;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max,
  color = 'primary',
  showPercentage = false,
  height = 'h-2',
  className = '',
}) => {
  const percentage = Math.min(Math.round((value / max) * 100), 100);
  
  const colorClasses = {
    primary: 'bg-primary',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
    secondary: 'bg-gray-500',
  };

  const getColorClass = () => {
    // For budgets, we want to change colors based on percentage
    if (color === 'primary') {
      if (percentage < 70) return colorClasses.success;
      if (percentage < 90) return colorClasses.warning;
      return colorClasses.danger;
    }
    
    return colorClasses[color];
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="relative">
        <div className="w-full rounded-full overflow-hidden" style={{height: height === 'h-2' ? '0.5rem' : height === 'h-3' ? '0.75rem' : '1rem', backgroundColor: '#e5e7eb'}}>
          <div
            className={`${getColorClass()} rounded-full transition-all duration-300`}
            style={{ width: `${percentage}%`, height: '100%' }}
          ></div>
        </div>
        {showPercentage && (
          <div className="mt-1 text-xs text-gray-500">
            {percentage}%
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
